export const NEW_PASSWORD_TEXTS = {
    TOAST_MESSAGES: {
        PASSWORD_MISMATCH: "Ups. Las contraseñas no coinciden. Prueba de nuevo.",
        PASSWORD_REQUIREMENTS: (
            <div>
                <p>Tu contraseña debe incluir:</p>
                -Entre 8 a 16 caracteres<br></br>
                -Al menos una letra mayúscula.<br></br>
                -Al menos una letra minúscula.<br></br>
                -Al menos un carácter especial (!@#$%^&*_=+;:,.?/~-).<br></br>
            </div>
        ),
        PASSWORD_CHANGE_FAILED: "No se pudo realizar el cambio de contraseña.",
        PASSWORD_RESET_FAILED: "No se logró restablecer la contraseña. Solicita nuevamente la recuperación de contraseña."
    },
    MAIN_TITLE: "Crea una contraseña segura",
    INSTRUCTIONS_PASSWORD: (
        <>La contraseña debe tener entre ocho y dieciséis caracteres <br></br> e incluir una combinación de números, letras, mayúsculas<br></br> y minúsculas, y caracteres especiales (!$@%*).</>
    ),
    BUTTON_LABEL: "Restablecer contraseña",
    REMEMBERED_PASSWORD_TEXT: "¿Recordaste tu contraseña?.",
    LOGIN_LINK_TEXT: "Inicia sesión"
};